<template>
  <section>
    <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="false"></b-loading>
    <h1 class="section-head">เพิ่มลูกค้า</h1>
    <div class="field is-horizontal">
      <a class="button is-danger is-pulled-left" @click="$router.go(-1)"><i class="fas fa-arrow-left"></i>กลับ</a>
    </div>
    <div class="column">

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ชื่อลูกค้า</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="ชื่อลูกค้า" v-model="customer.name">
              <span class="icon is-small is-left">
                <i class="fas fa-user"></i>
              </span>
            </p>
          </div>
          
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ที่อยู่</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="ที่อยู่" v-model="customer.address">
              <span class="icon is-small is-left">
                <i class="fas fa-map-marker-alt"></i>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">เบอร์โทรศัพท์</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="เบอร์โทรศัพท์" v-model="customer.phone">
              <span class="icon is-small is-left">
                <i class="fas fa-phone"></i>
              </span>
            </p>
          </div>

          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Fax.</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="Fax." v-model="customer.fax">
              <span class="icon is-small is-left">
                <i class="fas fa-phone"></i>
              </span>
            </p>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">E-Mail</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="E-Mail" v-model="customer.email">
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </p>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>


      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">เลขผู้เสียภาษี</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="เลขผู้เสียภาษี" v-model="customer.tax_no">
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </p>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ประเภทลูกค้า</label>
        </div>
        <div class="field-body">
          <div class="field ">
            <div class="control  has-icons-left">
              <div class="select">
                <select v-model="customer.type">
                  <option value="other">ทั่วไป</option>
                  <option value="pestguard">Pestguard Group</option>
                </select>
              </div>
              <span class="icon is-small is-left">
                <i class="fas fa-user"></i>
              </span>
            </div>
          </div>

          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>



      <div class="field is-horizontal">
        <div class="field-label">
          <!-- Left empty for spacing -->
        </div>
        <div class="field-body">
          <div class="field is-grouped">
            <p class="control">
              <button class="button is-primary" :class="loadingClass" v-on:click="submit">
                บันทึก
              </button>
            </p>
            <p class="control">
              <router-link class="button is-light" to="/customer">ยกเลิก</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import Request from '@/libraries/request'
  import CustomerModel from '@/model/customer_model'
  
  export default {
    name: "Customer_add",
    data() {
      return {
        customer: {
          name: "",
          address: "",
          phone: "",
          email: "",
          tax_no: "",
          fax: "",
          type: "other",
        },
        isLoading: true,
        loadingClass: "",
      }
    },
    methods: {
      submit() {
        this.loadingClass = "is-loading";
        let data = {
          id: this.$route.params.id ? this.$route.params.id : '',
          name: this.customer.name,
          address: this.customer.address,
          phone: this.customer.phone,
          email: this.customer.email,
          tax_no: this.customer.tax_no,
          fax: this.customer.fax,
          type: this.customer.type,
        }
        Request.post('customer/add',data, (res) => {
          if(res.data.status){
            this.loadingClass = "";
            this.$router.push('/customer/view/'+res.data.data.id);
          }
        });
      },
      async get_customer() {
        if(this.$route.params.id == 'undefined'){
          this.$buefy.snackbar.open('Customer ID not found.');
          this.$router.push('/customer');
        }else{
          try{
            const customer = await CustomerModel.get_customer(this.$route.params.id);
            this.customer = customer;
            this.isLoading = false;   
          }catch(e){
            this.$buefy.snackbar.open(e.message);
            this.$router.push('/customer');
          }
        }
      }
    },
    created() {
      if(this.$route.params.id){
        this.get_customer()
      }else{
        this.isLoading = false;
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/Customer/add.vue